export default (src) => {
  const input = src.split('base64,')[1];
  return input.replace(/=/g, '').length * 0.75;
};
